import { MainMenu } from './components/3-molecules/main-menu/main-menu.js'
import { Search } from './components/3-molecules/search/search.js'
import { Header } from './components/3-molecules/header/header.js'
import { ContentNav } from './components/3-molecules/content-nav/content-nav.js'
import { Lightbox } from './components/3-molecules/textmedia/lightbox.js'
import { DoughnutDiagram, BarDiagram } from './components/3-molecules/diagram/diagram.js'
import { IframeClickToPlay } from './components/3-molecules/video/youtube/youtube.js'

if (process.env.NODE_ENV === 'development') {
    import('./mocks/browser.js').then(({ worker }) => {
        worker.start({ onUnhandledRequest: 'bypass' })
    })
}

document.addEventListener('DOMContentLoaded', () => {
    const mainMenuElement = document.querySelector('[data-component="mainMenu"]')
    if (mainMenuElement) {
        // eslint-disable-next-line no-new
        new MainMenu(mainMenuElement)
    }

    const headerSearch = document.querySelector('[data-component="headerSearch"]')
    if (headerSearch) {
        // eslint-disable-next-line no-new
        new Search(headerSearch)
    }

    const search = document.querySelector('[data-component="search"]')
    if (search) {
        // eslint-disable-next-line no-new
        new Search(search, true)
    }

    const header = document.querySelector('[data-component="pageHeader"]')
    if (header) {
        // eslint-disable-next-line no-new
        new Header(header)
    }

    const iframeClickToPlay = document.querySelectorAll('[data-component="iframeClickToPlay"]')
    if (iframeClickToPlay) {
        iframeClickToPlay.forEach(element => {
            const iframe = element.querySelector('iframe')
            const fallback = element.querySelector('.js-youtube-fallback')
            const trigger = element.querySelector('.js-youtube-trigger')
            // eslint-disable-next-line no-new
            new IframeClickToPlay({ iframe, fallback, trigger }).init()
        })
    }

    const contentNav = document.querySelector('[data-component="contentNav"]')
    if (contentNav) {
        // eslint-disable-next-line no-new
        new ContentNav(contentNav)
    }

    const doughnutDiagram = document.querySelectorAll('[data-component="diagram"][data-diagram-type="doughnut"]')
    if (doughnutDiagram) {
        doughnutDiagram.forEach(item => {
            // eslint-disable-next-line no-new
            new DoughnutDiagram(item)
        })
    }

    const barDiagram = document.querySelectorAll('[data-component="diagram"][data-diagram-type="bar"]')
    if (barDiagram) {
        barDiagram.forEach(item => {
            // eslint-disable-next-line no-new
            new BarDiagram(item)
        })
    }

    const lightboxLinks = document.querySelectorAll('[data-component="lightboxLink"]')
    if (lightboxLinks && lightboxLinks.length > 0) {
        const galleries = {}
        lightboxLinks.forEach(link => {
            if (!link.dataset.gallery) {
                // eslint-disable-next-line no-new
                new Lightbox(link)
            } else {
                if (!Object.hasOwnProperty.call(galleries, link.dataset.gallery)) {
                    galleries[link.dataset.gallery] = true
                    // eslint-disable-next-line no-new
                    new Lightbox(document.querySelectorAll(`[data-component="lightboxLink"][data-gallery=${link.dataset.gallery}]`))
                }
            }
        })
    }

    window.addEventListener('load', () => {
        document.body.classList.add('is-loaded')
    })
})
